
import { computed, createVNode, ref } from 'vue'
import RenameModal from './RenameModal.vue'
import { Modal, message } from 'ant-design-vue'
import * as service from '../service'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { downLoadFromOss } from '@/utils/oss'
import { shareModeEnum } from '@/utils/dataMap'
import {
  STAT_EVENT,
  mineCoursewareStatResport
} from '@/utils/common/statReport'
import CardNameTitle from './CardNameTitle.vue'

export default {
  components: { RenameModal, CardNameTitle },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    look: {
      type: Boolean,
      default: () => false
    }
  },

  setup(props, { emit }) {
    const coursewareInfo = computed(() => props.value)
    const coursewareLook = computed(() => props.look)
    const coursewareName = ref(coursewareInfo.value.name || '')

    const fileInfo = ref(coursewareInfo.value.courseware)

    const loading = ref(false)
    const previewVisible = ref(false)
    const renameVisible = ref(false)

    const handleDownload = () => {
      downLoadFromOss(fileInfo.value.url, fileInfo.value.name)
    }

    const handleCancelPreview = () => { previewVisible.value = false }

    const handleCancelRename = () => { renameVisible.value = false }

    const handleRename = () => { renameVisible.value = true }

    // 编辑说课
    const handleEditSpeak = () => {
      if (fileInfo.value.share_mode === shareModeEnum.NOEDIT) {
        message.error('该说课不允许编辑')
        return
      }
      console.log('click ===> ', coursewareInfo.value)
      emit('onEdit', fileInfo.value)
    }

    const handleRenameOk = async (name) => {
      try {
        loading.value = true
        const params = {
          name
        }
        await service.renameCourseware(fileInfo.value.id, params)
        loading.value = false
        message.success('修改成功')
        emit('refresh')
        handleCancelRename()
        emit('refresh')
      } catch (error) {
        console.log(error)
        loading.value = false
      }
    }

    const handlePreview = () => { previewVisible.value = true }

    const handleDelete = async () => {
      console.log('delete')
      try {
        emit('showLoading', true)
        await service.deleteTeacherCourseware(fileInfo.value.id)
        mineCoursewareStatResport(STAT_EVENT.PREPARE_LESSON_MINECOURSEWARES_DELETE, {
          courseware_id: fileInfo.value.id,
          courseware_type: fileInfo.value.type
        })
        message.success('删除成功')
        emit('showLoading', false)
        emit('refresh')
      } catch (error) {
        console.log(error)
        emit('showLoading', false)
      }
    }

    const showDeleteWarning = () => {
      Modal.confirm({
        title: '警告',
        icon: createVNode(ExclamationCircleOutlined),
        content: '是否确认删除该文件？删除后将不可恢复',
        closable: true,
        onOk: handleDelete,
        onCancel: () => {
          Modal.destroyAll()
        }
      })
    }

    const handleMove = () => {
      emit('onMove', coursewareInfo.value)
    }

    // 分享课件
    const handleShare = () => {
      emit('onShare', coursewareInfo.value)
    }

    return {
      coursewareInfo,
      coursewareName,
      fileInfo,
      previewVisible,
      renameVisible,
      loading,
      shareModeEnum,
      handlePreview,
      handleRename,
      handleCancelRename,
      handleCancelPreview,
      handleRenameOk,
      handleDelete,
      handleDownload,
      showDeleteWarning,
      handleMove,
      handleShare,
      handleEditSpeak,
      coursewareLook
    }
  }
}

